import React from 'react';

interface MinusIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function MinusIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<MinusIconProps>) {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 8C2 7.44772 2.44772 7 3 7L13 7C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9L3 9C2.44772 9 2 8.55228 2 8Z"
				fill={fill}
			/>
		</svg>
	);
}
